export const defaultIconProps = { height: 32, width: 32, fill: 'currentColor' };
